<template>
  <main-template>
    <v-container>
      <v-row>
        <v-col cols="12" class="d-flex align-center">
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          <span class="text-h6 ml-2">Meios de pagamento</span>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">
          <div class="text-subtitle-2 grey--text mb-4">Selecione uma opção</div>

          <!-- Boleto e Pix -->
          <v-card
            outlined
            rounded="lg"
            class="mb-3 cursor-pointer"
            :class="formaSelecionada === 'boleto_pix' ? 'primary--border' : ''"
            :style="
              formaSelecionada === 'boleto_pix'
                ? 'border: 2px solid var(--v-primary-base) !important'
                : ''
            "
            @click="formaSelecionada = 'boleto_pix'"
          >
            <v-card-text class="d-flex align-center">
              <v-icon
                :color="formaSelecionada === 'boleto_pix' ? 'primary' : 'grey'"
                class="mr-3"
                size="32"
              >
                mdi-barcode-scan
              </v-icon>
              <div>
                <div class="text-subtitle-2 font-weight-bold">Boleto e Pix</div>
                <div class="text-caption grey--text">Pagamento à vista</div>
              </div>
              <v-spacer />
              <v-icon :color="formaSelecionada === 'boleto_pix' ? 'primary' : 'grey lighten-2'">
                {{
                  formaSelecionada === "boleto_pix" ? "mdi-radiobox-marked" : "mdi-radiobox-blank"
                }}
              </v-icon>
            </v-card-text>
          </v-card>

          <!-- Cartão de crédito (desabilitado visualmente) -->
          <v-card outlined rounded="lg" class="mb-3" style="opacity: 0.5; cursor: not-allowed">
            <v-card-text class="d-flex align-center">
              <v-icon color="grey" class="mr-3" size="32">mdi-credit-card-outline</v-icon>
              <div>
                <div class="text-subtitle-2 font-weight-bold grey--text">Cartão de crédito</div>
                <div class="text-caption grey--text">Em até 1x sem juros + taxa de 1.5%</div>
              </div>
              <v-spacer />
              <v-chip x-small color="grey lighten-2" class="grey--text text--darken-1">
                Em breve
              </v-chip>
            </v-card-text>
          </v-card>

          <!-- Bottom bar sticky -->
          <v-card class="bottom-bar-sticky mt-4 pa-4" elevation="8">
            <!-- Faixas de desconto -->
            <template v-if="parcela && parcela.descontosTiers.length > 0">
              <div class="text-caption grey--text mb-1">Descontos disponíveis</div>
              <div
                v-for="(tier, i) in parcela.descontosTiers"
                :key="i"
                class="d-flex justify-space-between"
              >
                <span
                  :class="
                    tierExpirado(tier)
                      ? 'text-caption grey--text text-decoration-line-through'
                      : tier.valor == parcela.descontoAplicavel
                      ? 'text-caption success--text font-weight-bold'
                      : 'text-caption grey--text'
                  "
                >
                  Até {{ tier.data | dateParse("YYYY-MM-DD") | dateFormat("DD/MM/YYYY") }}
                </span>
                <span
                  :class="
                    tierExpirado(tier)
                      ? 'text-caption grey--text text-decoration-line-through'
                      : tier.valor == parcela.descontoAplicavel
                      ? 'text-caption success--text font-weight-bold'
                      : 'text-caption grey--text'
                  "
                >
                  - {{ tier.valor | currency }}
                </span>
              </div>
              <v-divider class="my-2" />
            </template>

            <!-- Multa e juros (parcela atrasada) -->
            <template v-if="parcela && parcela.estaAtrasada">
              <div class="d-flex justify-space-between">
                <span class="text-caption error--text">Multa</span>
                <span class="text-caption error--text"
                  >+ {{ parcela.multaCalculada | currency }}</span
                >
              </div>
              <div class="d-flex justify-space-between mt-1">
                <span class="text-caption error--text">
                  Juros mora ({{ parcela.diasAtraso }}
                  {{ parcela.diasAtraso === 1 ? "dia" : "dias" }})
                </span>
                <span class="text-caption error--text"
                  >+ {{ parcela.jurosCalculados | currency }}</span
                >
              </div>
              <v-divider class="my-2" />
            </template>

            <div class="d-flex align-center mb-3">
              <span class="text-body-2 font-weight-medium">Total a pagar</span>
              <v-spacer />
              <div class="text-right">
                <div class="text-body-2 font-weight-bold">
                  {{ valorTotal | currency }}
                </div>
                <div v-if="formaSelecionada" class="text-caption grey--text">
                  {{ descricaoFormaSelecionada }}
                </div>
              </div>
            </div>
            <v-btn color="primary" block :disabled="!formaSelecionada" @click="continuar">
              Continuar
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MensalidadeFormaPagamento",

  computed: {
    ...mapGetters("Mensalidades", ["parcelasSelecionadas"]),

    matriculaId() {
      return this.$route.params.matricula_id;
    },
    parcelaId() {
      return this.$route.params.parcelaId;
    },

    totalSelecionadas() {
      return this.parcelasSelecionadas.reduce((acc, p) => acc + parseFloat(p.valor), 0);
    },

    valorTotal() {
      if (!this.parcela) return 0;
      return this.parcela.valorEmAberto;
    },

    descricaoFormaSelecionada() {
      if (this.formaSelecionada === "boleto_pix") return "no boleto ou Pix";
      return "";
    },
  },

  data() {
    return {
      formaSelecionada: "boleto_pix",
      parcela: null,
    };
  },

  mounted() {
    // pegar parcela no banco
    this.getParcela();
  },

  methods: {
    async getParcela() {
      this.parcela = await this.$services.parcelasService.getParcela(this.$route.params.parcelaId);
    },
    tierExpirado(tier) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return new Date(`${tier.data}T23:59:59`) < hoje;
    },
    continuar() {
      this.$store.commit("Mensalidades/setFormaPagamento", this.formaSelecionada);
      this.$router.push({
        name: "matriculas.mensalidades.confirmacao",
        params: { matricula_id: this.matriculaId, parcelaId: this.$route.params.parcelaId },
      });
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.bottom-bar-sticky {
  position: sticky;
  bottom: 0;
  z-index: 2;
}
</style>
